/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import MainLayout from '../../Layouts/Mainlayout'
import AddClientForm from './AddClientForm'
import AddClientTabs from './AddClientTabs'
import { useParams } from 'react-router-dom'

const AddClient: React.FC = () => {

    const param = useParams();
    const { id } = param;
    return (
        <div className="flex flex-row justify-start">
            <MainLayout>
                <AddClientTabs parentId={id} />
            </MainLayout>
        </div>
    )
}

export default AddClient